import * as React from "react";
import { connect } from "react-redux";
import { toast, ToastContainer } from "react-toastify";
import { DropdownMultiSelect } from "../../Common/Components/DropdownMultiSelect";
import {
  Container,
  Dropdown,
  Form,
  Button,
  Spinner,
} from "react-bootstrap";
import BootstrapTable from "react-bootstrap-table-next";
import cellEditFactory from "react-bootstrap-table2-editor";
import { LocationService } from "../../Common/Services/LocationService";
import { Utils } from "../../Common/Utilis";
import { BankService } from "../../Common/Services/BankService";
import { resolve, reject } from "q";
import "../../App.scss";
import { VendorSearch } from "../../Common/Components/VendorSearch";
import { Typeahead, Menu, MenuItem } from "react-bootstrap-typeahead";
import EllipsisWithTooltip from "react-ellipsis-with-tooltip";
import { FiChevronDown } from "react-icons/fi";
import moment from "moment";
import { confirmAlert } from "react-confirm-alert";
import { faArrowUp } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import ScrollContainer from "react-indiana-drag-scroll";
import { CommentBox } from "../../Common/Components/CommentBox";
import { SingleDropdownListWithoutSearch } from "../../Common/Components/SingleDropdownListWithoutSearch";
import DatePicker from "react-datepicker";

let routeLeavingGuard: any = null;
let requestInProcess = false;
class CreditCardMasterSlidout extends React.Component<any, any> {

  private parentScroll: any;
  private accountNoRef: any;
  private customerSearch: any;

  constructor(props: any) {
    super(props);
    this.parentScroll = React.createRef();
    this.accountNoRef = React.createRef();
    this.customerSearch = React.createRef();
    this.state = {
      coaList: [],
      lock: false,
      bankList: [],
      editAccountNo: false,
      showField: false,
      BankName: "Select",
      accountTypeList: [{ id: 'Checking', name: 'Checking' }, { id: 'Savings', name: 'Savings' }],
      selectOptions: [
        {
          id: 'Active', name: 'Active'
        },
        { id: 'Inactive', name: 'Inactive' }

      ],
      formData: {
        id: this.props.bankId,
        AccountNo: '',
        lastAccountNo: '',
        city: "",
        state: "",
        zip: "",
        phone: "",
        email: "",
        sharingid: 0,
        ispayrollDefault: false,
        isprimary: false,
        coa: "",
        status: "Active",
        vendorid: 0,
        Date: new Date()
      },

    };

  }


  beforeunload(e: { preventDefault: () => void; returnValue: boolean }) {
    if (
      this.state.isStateChanged &&
      routeLeavingGuard !== "routeLeavingGuardTrue"
    ) {
      e.preventDefault();
      e.returnValue = true;
    }
  }

  routeLeavingGuardConfirm = (childState: any) => {
    if (childState === true) {
      routeLeavingGuard = "routeLeavingGuardTrue";
    } else {
      routeLeavingGuard = null;
    }
  };

  componentDidMount() {
    this.getBankMaster();

    if (this.props.bankId == 0) {
      this.setState({ showField: true, editAccountNo: true });
      // this.existingBankMaster();
    }
  }

  componentDidUpdate(prevProps, prevState) {
    // Focus the input field when editAccountNo is set to true
    // if (this.state.editAccountNo && this.state.editAccountNo !== prevState.editAccountNo) {
    //   this.accountNoRef.current.focus();
    // }
    if (prevProps.locationId != this.props.locationId) {
      this.closeSlideOut();
    }
  }

  existingBankMaster = async () => {
    const { requestlist } = this.state;

    try {
      const locations = await LocationService.GetLocationAll({ ...requestlist });

      if (!Array.isArray(locations) || locations.length === 0) return;
      const locWithType1 = locations.find(loc => loc.locType === 1);
      if (!locWithType1) return;

      const updatedRequest = {
        ...requestlist,
        locationId: locWithType1.locationId,
      };

      const banks = await BankService.GetBanks1(updatedRequest);

      if (banks) {
        const bank = banks.map(bank => ({
          ...bank,
          name: bank.bankName,
        }));

        this.setState({ bankList: bank });
      }
    } catch (err) {
      toast.error(`Server Error: ${err}`);
    }
  };

  handleSelectedItem1 = (control: any, id: any) => {
    this.setState(prevState => ({
      formData: {
        ...prevState.formData,
        status: id
      }
    }));
  };
  handleSelectedItem = (control: any, id: any) => {
    if (this != undefined) {
      if (control === 'AccountType') {
        let formData = this.state.formData;
        formData.AccountType = id;
        this.setState({ formData, isStateChanged: true });
      } if (control === 'Loadprev') {
        const selectedBank = this.state.bankList.find(bank => bank.id === parseInt(id));
        if (selectedBank) {
          const formData = {
            sharingid: selectedBank.id,
            id: 0,
            BankName: selectedBank.bankName,
            AccountNo: selectedBank.accountNo,
            Balance: selectedBank.balance,
            locationId: selectedBank.locationId,
            Phone: selectedBank.phone,
            Email: selectedBank.email,
            RoutingNumber: selectedBank.routingNumber,
            AccountType: selectedBank.accountType,
            accountname: selectedBank.accountname,
            displayname: selectedBank.displayname,
            bankcode: selectedBank.bankcode,
            bankStreet1: selectedBank.bankStreet1,
            bankStreet2: selectedBank.bankStreet2,
            status: selectedBank.status,
            abarounting: selectedBank.abarounting,
            startingcheck: selectedBank.startingcheck,
            checkseries: selectedBank.checkseries,
            street: selectedBank.street,
            city: selectedBank.city,
            state: selectedBank.state,
            zip: selectedBank.zip,
            lastAccountNo: selectedBank.lastAccountNo,
            nickname: selectedBank.nickName,
          };

          this.setState({ formData, isStateChanged: true, BankName: selectedBank.bankName, lock: true, accountTypeList: [] }, () => {
            // this.setState({      
            //   accountTypeList: [{ id: 'Checking', name: 'Checking' }, { id: 'Savings', name: 'Savings' }],});
          });
        }
      }


    }
  };

  getBankMaster = () => {

    let requestlist = { ...this.state.requestlist };
    requestlist.bankId = this.props.bankId;
    BankService.GetBankMasterById(requestlist)
      .then(async (result: any | null) => {

        if (result != null) {
          let formData = { ...this.state.formData };

          formData.id = result.id;
          formData.BankName = result.bankName;
          formData.TenantId = result.tenantId;
          formData.AccountNo = result.accountNo;
          formData.CardNo = result.cardNo;
          formData.lastAccountNo = result.lastAccountNo;
          formData.lastCardNo = result.lastCardNo;
          formData.AccountType = result.accountType;
          formData.RoutingNumber = result.routingNumber;
          formData.Date = result.openingDate;

          formData.Email = result.email;
          formData.Phone = result.phone;
          formData.street = result.street;
          formData.status = result.status;
          formData.zip = result.zip;
          formData.nickname = result.nickName;
          formData.startingcheck = result.startingcheck;
          formData.checkseries = result.checkseries;
          formData.Balance = Utils.currencyFormat(result.balance);
          formData.city = result.city;
          formData.state = result.state;
          formData.sharingid = result.sharingid;
          formData.ispayrollDefault = result.ispayrollDefault;
          formData.isprimary = result.isprimary;
          formData.coa = result.coa;
          formData.vendorid = result.vendorid;
          let editAccountNo = (formData.AccountNo == null || formData.AccountNo == '' || formData.AccountNo.length < 5);

          let custommerSelected: any = [];
          custommerSelected.company_name = result.bankName;
          custommerSelected.customer_id = result.vendorid;

           this.customerSearch?.current.handleSelectFromParent(
              custommerSelected
            );

          this.setState({ formData: formData, showField: true, editAccountNo: editAccountNo, lock: result.sharingid == 0 ? false : true, coaList: [] });
        }
        resolve();
      })
      .catch((err: any) => {
        toast.error(`Server Error, ${err}`);
        reject();
      });
  };


  //Save all entered data into db and handle the created vendor as selected in dropdown
  saveItem = async () => {
    const { formData } = this.state;
    if (requestInProcess == true) {
      toast.error("Subsequent request has been made.", {
        position: toast.POSITION.BOTTOM_RIGHT,
      });
      return;
    }

    

    if (!formData.AccountNo || formData.AccountNo.trim() === "") {
      toast.error("Card No. is required.", { position: toast.POSITION.BOTTOM_RIGHT });
      return;

    }

      if (formData.AccountNo.length < 4 ) {
      toast.error("Please enter a valid card no.", { position: toast.POSITION.BOTTOM_RIGHT });
      return;
    }


    if (!formData.BankName || formData.BankName.trim() === "") {
      toast.error("Card Vendor is required.", { position: toast.POSITION.BOTTOM_RIGHT });
      return;
    }




    if (!formData.coa || formData.coa.trim() === "") {
      toast.error("COA is required.", { position: toast.POSITION.BOTTOM_RIGHT });
      return;
    }

    if (formData.coa.length != 4) {
      toast.error("COA length doesn't match.", { position: toast.POSITION.BOTTOM_RIGHT });
      return;
    }


    if (!formData.nickname || formData.nickname.trim() === "") {
      toast.error("Nickname is required.", { position: toast.POSITION.BOTTOM_RIGHT });
      return;
    }

    this.state.formData.OpeningDate = Utils.toLocalISOString(new Date(this.state.formData.Date));

    // console.log("**************", this.state.formData);
    // return;
    this.setState({ isSaveSpinner: true });
    requestInProcess = true;

    this.state.formData.Balance = parseFloat(Utils.removecurrencyFormat(this.state.formData.Balance ? this.state.formData.Balance : 0));
    this.state.formData.isBank = false;
    BankService.SaveCardMaster(this.state.formData)
      .then(async (result: any | null) => {


        if (result !== null) {

          if (result.accountNo == "duplicate") {
            toast.error("Account no. / Card no already exists.",
              {
                position: toast.POSITION.BOTTOM_RIGHT,
              }
            );
          }
          else if (result.coa == "duplicate") {
            toast.error("COA already exists.",
              {
                position: toast.POSITION.BOTTOM_RIGHT,
              }
            );
          }
          else if (formData.id > 0) {
            let requestlist: any = {};
            toast.success("Details updated successfully.",
              {
                position: toast.POSITION.BOTTOM_RIGHT,
              }
            );
            this.getBankMaster();
          } else if (formData.id == null || formData.id == 0 || formData.id == "") {
            let requestlist: any = {};
            toast.success("Credit card created successfully.",
              {
                position: toast.POSITION.BOTTOM_RIGHT,
              }
            );
          } else {
            toast.error(result.message, {
              position: toast.POSITION.BOTTOM_RIGHT,
            });
          }
        }

        this.setState({ isSaveSpinner: false, editAccountNo: false });
        requestInProcess = false;
        if (result.accountNo !== "duplicate" && result.coa !== "duplicate" && (!formData.id || formData.id == 0 || formData.id == "")) this.closeSlideOut();
        resolve();
      })
      .catch((error) => {
        this.setState({ isSaveSpinner: false });
        requestInProcess = false;
        reject();
      }
      );
  };

  onAmountFocus = (e, index, txtID, type: any) => {
    const { formData } = this.state;


    let start = e.target?.selectionStart;
    let end = e.target?.selectionEnd;
    if (type === "Balance") {
      let newVal = Utils.removeInvaildCharFromAmount(e.target.value);
      e.target.value = newVal;
      formData.Balance = e.target.value;


    }
  };



  amountBlur = (e, rowIndex, type: any, row: any) => {
    const { formData } = this.state;
    if (type === "Balance") {
      let newVal = Utils.removeInvaildCharFromAmount(e.target.value);
      e.target.value = newVal;
      formData.Balance =
        e.target.value === ""
          ? ""
          : !isNaN(e.target.value)
            ? Utils.currencyFormat(e.target.value)
            : e.target.value;
      // }
    }
    this.setState({ formData }, () => { });
  };


  closeSlideOut = () => {
    this.props.closeSlideOut(this.state?.shouldReloadMainPage);
  };

  handleChange = (event: any, FieldType: string) => {

    let isStateChanged = true;

    let formData = { ...this.state.formData };

    if (FieldType === "BankName") {
      formData.BankName = event.target.value;
    }
    else if (FieldType === "AccountNo") {
      formData.AccountNo = event.target.value;
      formData.lastAccountNo = event.target.value;
    }

    else if (FieldType === "nickname") {

      formData.nickname = event.target.value;
    }
    else if (FieldType === "isprimary") {
      formData.isprimary = event.target.checked;
    } else if (FieldType === "status") {
      formData.status = event.target.checked == true ? "Active" : "Inactive";
    } else if (FieldType === "coa") {
      let val = event.target.value.replace(/[^0-9()-\s]/g, '');

      formData.coa = val;

    } else if (FieldType === "Date") {
      let today = new Date(event);
      let dateNew =
        today.getMonth() +
        1 +
        "/" +
        today.getDate() +
        "/" +
        today.getFullYear().toString().substring(2, 4);
      let todaynew = new Date(dateNew);
      let dateNewt =
        todaynew.getMonth() +
        1 +
        "/" +
        todaynew.getDate() +
        "/" +
        todaynew.getFullYear().toString().substring(0, 4);
      formData.Date = dateNewt;
    }


    this.setState({ formData, isStateChanged, isSpinner: false }, () => {

    });
  };

  updateMultiSelectItem = (selectedItems: any[]) => {
    const { formData } = this.state;

    const selectedValues = selectedItems.map((item) => parseInt(item.value, 10));

    this.setState({
      formData: {
        ...formData,
        selectedIds: selectedValues,
      },
      isStateChanged: true
    });
  };

  updateCustomerList = (result: any) => {
    this.setState({ customerList: [] }, () => {
      this.setState({ customerList: result });
    });
  };


  handleVendorChange = (e: any) => {

    let isStateChanged = true;
    let formData = { ...this.state.formData };
    if (e.length > 0) {
      this.state.formData.vendorid = e[0].vendor_id;
      this.state.formData.BankName = `${e[0].company_name} (${e[0].vendorcode})`;

    } else {
      this.state.formData.vendorid = 0;
      this.state.formData.BankName = "";
    }
  };

  render() {
    const { permissions } = this.props;
    const hasAddPermission = permissions && permissions['Bank Master'] ? permissions['Bank Master'].includes('Add Bank') : false;
    const hasEditPermission = permissions && permissions['Bank Master'] ? permissions['Bank Master'].includes('Edit Bank') : false;

    const {
      lock

    } = this.state;


    return (
      //  <div className="transaction-slideout invoice-entry pos-fxd index-1000">

      <section>
        <div className="details-drawer"
          style={{ minWidth: "55%", width: "500px", maxWidth: "100%" }}
        // className="back-drop1  viewer-panel1 opacity "
        >
          <ToastContainer
            containerId={"userDetailSlideoutcontainer"}
            autoClose={3000}
          />

          <div className="d-flex">
            {!this.state.isOpenViewer && (
              <div
                className="back-drop1  viewer-panel1 opacity "
                onClick={() => this.closeSlideOut()}
              ></div>
            )}

            <Container
              fluid

              className="body-sec viewer-panel back-drop p-0 "
              style={{ minWidth: "50%", width: "550px", maxWidth: "100%" }}

            >
              <div
                className="container-fluid py-1 bg-white d-flex align-items-center  border-bottom round-4"
              >
                <div className="divheader">
                  <h5 className="my-title">
                    {this.state.formData.id == 0 ? <span>New Credit Card Account</span> : <span> Credit Card Account Details </span>}

                  </h5>
                  {this.state.formData.sharingid != 0 &&
                    <span className="badge badge-pill badge-primary color-green">
                      Shared Bank
                    </span>
                  }


                  <div className="header-popout ml-auto">





                    <div className="container text-center">
                      <div className="row align-items-start">
                        <div className="col">
                        </div>

                        <div className="col">
                          <button
                            type="button"
                            className="btn btn-primary cross"
                            onClick={this.closeSlideOut}
                          >
                            <svg
                              width="24"
                              height="24"
                              viewBox="0 0 24 24"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <path
                                d="M16.192 6.34399L11.949 10.586L7.70697 6.34399L6.29297 7.75799L10.535 12L6.29297 16.242L7.70697 17.656L11.949 13.414L16.192 17.656L17.606 16.242L13.364 12L17.606 7.75799L16.192 6.34399Z"
                                fill="#ffffff"
                              />
                            </svg>
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>


              <div
                className="scroll"
              >

                <section className="pb-3">
                  <div className="container-fluid">

                     <div className="row align-items-center mb-3">
                      <div className="col-md-4">
                        <Form.Label>Card No</Form.Label>
                      </div>
                      <div className="col-md-6">
                        <Form.Control
                          type="text"
                          value={ this.state.formData.AccountNo}
                          disabled={lock}
                          placeholder="Enter Card Number"
                          autoComplete="off"
                          onChange={(e) => this.handleChange(e, "AccountNo")}
                        />
                      </div>
                    </div>


                    <div className="row align-items-center mb-3">
                      <div className="col-md-4">
                        <Form.Label>Card Vendor</Form.Label>
                      </div>
                      <div className="col-md-6">
                        <VendorSearch
                          ref={this.customerSearch}
                          updateCustomerList={this.updateCustomerList}
                          handleVendorChange={
                            this.handleVendorChange
                          }
                        />
                      </div>
                    </div>


                  
                    <div className="row align-items-center mb-3">
                      <div className="col-md-4">
                        <Form.Label>COA</Form.Label>
                      </div>
                      <div className="col-md-6">
                        <Form.Control
                          type="text"
                          value={this.state.formData.coa}
                          disabled={lock}
                          autoComplete="off"
                          placeholder="Enter COA"
                          onChange={(e) => this.handleChange(e, "coa")}
                        />
                      </div>
                    </div>

                    <div className="row align-items-center mb-3">
                      <div className="col-md-4">
                        <Form.Label>Nickname</Form.Label>
                      </div>
                      <div className="col-md-6">
                        <Form.Control
                          type="text"
                          value={this.state.formData.nickname}
                          disabled={lock}
                          autoComplete="off"
                          placeholder="Enter Nickname"
                          onChange={(e) => this.handleChange(e, "nickname")}
                        />
                      </div>
                    </div>

                    <div className="row align-items-center mb-3">
                      <div className="col-md-4">
                        <Form.Label>Opening Date</Form.Label>
                      </div>
                      <div className="col-md-6">
                        <DatePicker
                          className="form-control w-75"
                          placeholderText="MM/DD/YY"
                          dateFormat="MM/dd/yy"
                          selected={
                            this.state.formData.Date === null
                              ? null
                              : this.state.formData.Date === ""
                                ? null
                                : new Date(this.state.formData.Date)
                          }
                          onChange={(date) => this.handleChange(date, "Date")}
                        />
                      </div>
                    </div>

                    <div className="row align-items-center mb-3">
                      <div className="col-md-4">
                        <Form.Label className="mb-0">Primary Account</Form.Label>
                      </div>
                      <div className="col-md-6">
                        <Form.Check
                          type="switch"
                          checked={this.state.formData.isprimary}
                          onChange={(e) => this.handleChange(e, "isprimary")}
                        />
                      </div>
                    </div>

                    <div className="row align-items-center mb-3">
                      <div className="col-md-4">
                        <Form.Label className="mb-0">Active</Form.Label>
                      </div>
                      <div className="col-md-6">
                        <Form.Check
                          type="switch"
                          checked={this.state.formData.status === "Active"}
                          onChange={(e) => this.handleChange(e, "status")}
                        />
                      </div>
                    </div>

                  </div>
                </section>



                {/* <div className="filter-sec height-100">

                  <br></br>
                  <br></br>

                </div> */}






                <div className={"footer-section viewer-panel"}
                  style={{ minWidth: "50%", width: "550px", maxWidth: "100%" }}
                >
                  <div>
                    <div className="d-flex align-items-center justify-content-end height-72">
                      <div className="d-flex align-items-center">
                        {((hasEditPermission && this.state.formData.id > 0) || (hasAddPermission && this.state.formData.id === 0)) &&
                          (
                            <>
                              <Button
                                variant="primary"
                                type="button"
                                className="space btn btn-primary btn-discard"
                                onClick={this.closeSlideOut}
                              >
                                Discard
                              </Button>
                              <Button
                                id="btnSave"
                                variant="primary"
                                type="button"
                                onClick={() => this.saveItem()}

                              >
                                {this.state.formData.id == 0 ? "Create" : "Update"}
                              </Button>



                            </>
                          )}
                      </div>
                    </div>
                  </div>
                </div>
              </div>

            </Container>
          </div>



          {(this.state.isSpinner || this.state.isSaveSpinner) && (
            <div className="loader-spinner d-flex justify-content-center align-items-center">
              <Spinner animation="border" variant="success" />
            </div>
          )}






        </div>
      </section>

    );
  }
}

const mapStateToProps = (state) => ({
  permissions: state.PagePermissionReducer.permissions,
  locationId: state.LocationReducer.locationId
});

export default connect(mapStateToProps)(CreditCardMasterSlidout);